<template>
  <div class="page prescription-page">
    <div class="page-title">График приема</div>

    <SchedulePager
      :date="date"
      :setDate="setDate" />

    <div v-if="!isLoaded" class="loader"></div>
    <div v-else-if="prescriptions.length === 0"
         class="prescriptions-empty">
      Сразу после первого приема препарата нажмите "начать" в разделе "Назначения", <br />и дальнейший график приема сформируется автоматически.
    </div>

    <ScheduleList
      :date="date"
      :prescriptions="prescriptions" />
  </div>
</template>

<script>
  import calculateDaysCount from '../utils/calculateDaysCount';
  import formatDate from '../utils/formatDate';
  import {MS_IN_DAY} from '../constants';
  import SchedulePager from "./schedule/Pager";
  import ScheduleList from "./schedule/List";

  export default {
    name: 'Schedule',

    components: {ScheduleList, SchedulePager},

    data() {
      return {
        date: new Date(),
      };
    },

    computed: {
      isLoaded() {
        return this.$store.state.prescriptionsLoaded;
      },

      prescriptions() {
        return this.$store.state.prescriptions.filter(prescription => {
          if (prescription.startedAt === null) {
            return false;
          }

          const daysPrescribed = calculateDaysCount(prescription.startDate, prescription.finishDate);
          const startDate = new Date(prescription.startedAt);
          const finishDate = new Date(startDate.getTime() + daysPrescribed * MS_IN_DAY);
          const from = formatDate(startDate, 'ymd');
          const to = formatDate(finishDate, 'ymd');
          const day = formatDate(this.date, 'ymd');

          return from <= day && day <= to;
        });
      },
    },

    methods: {
      setDate(date) {
        this.date = date;
      },
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .prescription-page {
    .prescriptions-empty {
      margin: 0 20px 20px;
    }
  }
</style>
